<template>
  <section class="footer">
    <div>
      <ul class="f_nav">
        <a href="https://block.contec.kr" target="_blank"><li data-lang="btn_block_coding">BLOCK CODING</li></a>
        <a href="https://ai.contec.kr/" target="_blank"><li data-lang="btn_ai">AI</li></a>
        <a href="http://dev-one.contec.kr/" target="_blank"><li data-lang="btn_contec_one">CONTEC ONE</li></a>
        <a href="http://contec.kr/" target="_blank"><li data-lang="btn_contec">CONTEC.KR</li></a>
      </ul>
      <ul class="footer-1">
        <li><b>OFFICE</b>+82-42-863-4523</li>
        <li><b>MOBLE</b>+82-10-3108-4523</li>
        <li><b>FAX</b>+82-42-863-4523</li>
        <li><b>EMAIL</b>shlee@contec.kt</li>
        <li><b>HEAD</b>169-84 Gwahak-ro, Yuseong-gu, Daejeon, Republic of korea, 34133</li>
        <li><b>LAB</b>82, Jijokbuk-ro 66beon-gil, Yuseong-gu, Deajeon, 34070</li>
        <li>Terms and conditions Policy of processing of personal information</li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>